import { PhoneNumber } from 'libphonenumber-js';

import IJobCandidateInteractionDTO from '../types/IJobCandidateInteractionDTO';

const handleValidity = (
  parsedPhoneNumber: PhoneNumber,
  processedCandidate: IJobCandidateInteractionDTO
) => {
  if (
    parsedPhoneNumber.isValid() &&
    (parsedPhoneNumber.countryCallingCode === '1' || parsedPhoneNumber.countryCallingCode === '61')
  ) {
    if (!processedCandidate.phoneNumber) {
      processedCandidate.phoneNumber = parsedPhoneNumber.number;
      processedCandidate.countryCallingCode = parsedPhoneNumber.countryCallingCode as string;
    } else {
      processedCandidate.alternatePhoneNumbers?.push(parsedPhoneNumber.number);
    }
  }
};

export default handleValidity;
